export const FETCH_AUDIT_EVENTS = 'FETCH_AUDIT_EVENTS';
export const FETCH_AUDIT_EVENTS_SUCCESS = 'FETCH_AUDIT_EVENTS_SUCCESS';
export const FETCH_AUDIT_EVENTS_FAIL = 'FETCH_AUDIT_EVENTS_FAIL';

export const FETCH_AUDIT_USERS = 'FETCH_AUDIT_USERS';
export const FETCH_AUDIT_USERS_SUCCESS = 'FETCH_AUDIT_USERS_SUCCESS';
export const FETCH_AUDIT_USERS_FAIL = 'FETCH_AUDIT_USERS_FAIL';
